import { render, staticRenderFns } from "./payRecord.vue?vue&type=template&id=6c68079b&scoped=true&"
import script from "./payRecord.vue?vue&type=script&lang=js&"
export * from "./payRecord.vue?vue&type=script&lang=js&"
import style0 from "./payRecord.vue?vue&type=style&index=0&id=6c68079b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c68079b",
  null
  
)

export default component.exports